import moment from "moment";
import { useState } from "react";
import Modal from "../components/modal";
import { getStatusLabel } from "../utils/statusLabel";
import Button from "../components/button";

const ItemBillet = props => {

    const [openReceivers, setOpenReceivers] = useState(false);
    const [openAnticipate, setOpenAnticipate] = useState(false);

    return(
        <>
            <tr className="border-b">
                <td className="py-2 px-4 text-sm text-gray-700">{parseFloat(props?.billet?.value).toLocaleString('pt-BR',{style: 'currency', currency:'BRL'})}</td>
                <td className="py-2 px-4 text-sm text-gray-700">{parseFloat(props?.billet?.value*(props?.billet?.tax_percentage/100)).toLocaleString('pt-BR',{style: 'currency', currency:'BRL'})} {props?.billet?.tax_percentage && `(${props?.billet?.tax_percentage}%)`}</td>
                <td className="py-2 px-4 text-sm text-gray-700">{props?.billet?.due_date && moment(props?.billet?.due_date).format('DD/MM/YYYY')}</td>
                <td className="py-2 px-4 text-sm text-gray-700">{getStatusLabel(props?.billet?.status)}</td>
                <td className="py-2 px-4 text-sm text-blue-700">
                    <span 
                        className="cursor-pointer" 
                        onClick={() => {
                            setOpenReceivers(true);
                        }}
                    >
                        Ver recebedores
                    </span>
                </td>
                <td className="py-2 px-4 text-sm text-blue-700">
                    {props?.billet?.url && (
                        <span 
                            className="cursor-pointer" 
                            onClick={() => {
                                window.open(props?.billet?.url, '_blank');
                            }}
                        >
                            Visualizar boleto
                        </span>
                    )}
                </td>
                <td>
                    {props?.billet?.url && (
                        <Button 
                            size="small"
                            onClick={() => {
                                setOpenAnticipate(true);
                            }}
                        >
                            Antecipar
                        </Button>
                    )}
                </td>
            </tr>
            
            <Modal
                isOpen={openReceivers}
                onClose={() => setOpenReceivers(false)}
                title="Recebedores"
            >
                <table className="min-w-full table-auto border-collapse">
                    <thead>
                        <tr className="border-b">
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Nome</th>
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Percentual</th>
                            <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Valor</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {props?.billet?.receivers?.map((receiver) => (
                            <tr className="border-b">
                                <td className="py-2 px-4 text-sm text-gray-700">{receiver?.name}</td>
                                <td className="py-2 px-4 text-sm text-gray-700">{receiver?.percentage}%</td>
                                <td className="py-2 px-4 text-sm text-gray-700">{parseFloat(receiver?.value).toLocaleString('pt-BR',{style: 'currency', currency:'BRL'})}</td>
                                <td className="py-2 px-4 text-sm text-gray-700">{receiver?.status}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Modal>

            <Modal
                isOpen={openAnticipate}
                onClose={() => setOpenAnticipate(false)}
                title="Antecipação"
            >
                <div className="text-sm text-gray-700 space-y-4">
                    <p>
                        A solicitação será analisada e pode levar até <strong>3 dias</strong> para ser processada.
                    </p>

                    <p>
                        Durante a análise, poderão ser solicitadas algumas validações adicionais para garantir a segurança da operação.
                    </p>

                    {(() => {
                        const bruto = parseFloat(props?.billet?.value);
                        const taxaLucro = (props?.billet?.tax_percentage || 0) / 100;
                        const taxaAntecipacao = 0.10;

                        const valorTaxaLucro = bruto * taxaLucro;
                        const valorTaxaAntecipacao = bruto * taxaAntecipacao;
                        const liquido = bruto - valorTaxaLucro - valorTaxaAntecipacao;

                        const hoje = new Date();
                        const vencimento = new Date(props?.billet?.due_date);
                        const diffEmDias = Math.ceil((vencimento - hoje) / (1000 * 60 * 60 * 24));

                        const minDias = 8;
                        const maxDias = 90;
                        const podeAntecipar = diffEmDias >= minDias && diffEmDias <= maxDias;

                        return (
                            <>
                                {!podeAntecipar && (
                                    <div className="p-4 mb-4 bg-yellow-100 text-yellow-800 border border-yellow-300 rounded">
                                        Antecipação para boletos com vencimento de <strong>{minDias} dias</strong> e no máximo <strong>{maxDias} dias</strong> de antecedência ao vencimento.
                                        <br />
                                    </div>
                                )}

                                <div className="bg-gray-50 border border-gray-200 rounded p-4">
                                    <p className="mb-2 font-semibold">Resumo da Antecipação:</p>

                                    <div className="flex justify-between mb-1">
                                        <span>Valor bruto:</span>
                                        <span>{bruto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                    </div>
                                    <div className="flex justify-between mb-1">
                                        <span>Taxa da Lucro Tech ({props?.billet?.tax_percentage}%):</span>
                                        <span>{valorTaxaLucro.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                    </div>
                                    <div className="flex justify-between mb-1">
                                        <span>Taxa de antecipação (10%):</span>
                                        <span>{valorTaxaAntecipacao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                    </div>
                                    <div className="flex justify-between font-semibold text-green-600">
                                        <span>Valor líquido final:</span>
                                        <span>{liquido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                    </div>
                                </div>

                                <div>
                                    <p className="font-semibold mb-2 mt-4">Divisão entre recebedores:</p>
                                    <table className="min-w-full table-auto border-collapse">
                                        <thead>
                                            <tr className="border-b">
                                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Nome</th>
                                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Percentual</th>
                                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Valor original</th>
                                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Valor com taxa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {props?.billet?.receivers?.map((receiver, idx) => {
                                                const originalValue = bruto * (receiver.percentage / 100);
                                                const netValue = liquido * (receiver.percentage / 100);

                                                return (
                                                    <tr className="border-b" key={idx}>
                                                        <td className="py-2 px-4 text-sm text-gray-700">{receiver?.name}</td>
                                                        <td className="py-2 px-4 text-sm text-gray-700">{receiver?.percentage}%</td>
                                                        <td className="py-2 px-4 text-sm text-gray-700">
                                                            {originalValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                        </td>
                                                        <td className="py-2 px-4 text-sm text-gray-700">
                                                            {netValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="mt-6 text-right">
                                    <Button
                                        size="medium"
                                        disabled={!podeAntecipar}
                                        onClick={() => {
                                            console.log("Solicitação de antecipação enviada");
                                            setOpenAnticipate(false);
                                        }}
                                        title={!podeAntecipar ? `Só é possível antecipar entre ${minDias} e ${maxDias} dias antes do vencimento` : ''}
                                    >
                                        Confirmar antecipação
                                    </Button>
                                </div>
                            </>
                        );
                    })()}

                </div>
            </Modal>

        </>
    )
}

export default ItemBillet;